import React from "react";
import { useNavigate } from "react-router-dom";
import { Calendar } from "lucide-react";


const UtilitySystemsDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="px-2 py-4 mt-14 w-full h-full">
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Utility Systems Dashboard
        </h1>
        <p className="text-gray-600">
          This is Utility Systems including Construction & Renovation module.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <button
          onClick={() => navigate("/utility-systems/maintenance/schedules")}
          className="bg-white rounded-lg shadow p-6 text-left hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center gap-4 mb-3">
            <div className="bg-[#2196F3] bg-opacity-10 p-3 rounded-lg">
              <Calendar className="w-8 h-8 text-[#2196F3]" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800">
              Maintenance Schedules
            </h3>
          </div>
          <p className="text-gray-600 text-sm">
            View and manage all maintenance schedules
          </p>
        </button>
      </div>
    </div>
  );
};

export default UtilitySystemsDashboard;

